import { inject, Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { LoadingService } from '@portal/loading/data-access';
import { catchError, combineLatest, finalize, mergeMap, take, throwError } from 'rxjs';
import { ROUTE } from '../constant/route.constant';
import { RouteErrorCode } from '../type/route.type';
import { BizflexFacade } from '../store';
import { SignOffTypeParam } from '../type/sign-off.type';
import { HttpErrorResponse } from '@angular/common/http';
import { PersonnelType } from '@core/data-access';

@Injectable({ providedIn: 'root' })
export class SignManualResolver implements Resolve<boolean> {
  private readonly bizflexFacade = inject(BizflexFacade);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);

  resolve() {
    this.loadingService.show();

    return combineLatest([this.bizflexFacade.jwt$.pipe(take(1)), this.bizflexFacade.directors$.pipe(take(1))]).pipe(
      mergeMap(([jwt, directors]) => {
        if (!jwt) return throwError(() => new Error('JWT is not available'));
        if (jwt?.type === PersonnelType.entity) {
          return this.router.navigate([
            ROUTE.SUCCESS.MAIN,
            ROUTE.SUCCESS.SIGN_OFF,
            directors && directors.length > 1 ? SignOffTypeParam.Multi : SignOffTypeParam.Single,
          ]);
        }

        return this.router.navigate([ROUTE.SUCCESS.MAIN, ROUTE.SUCCESS.SIGN_OFF, SignOffTypeParam.Single]);
      }),
      catchError((error: HttpErrorResponse) => this.navigateErrorPage()),
      finalize(() => this.loadingService.hide()),
    );
  }

  private navigateErrorPage(errorCode?: RouteErrorCode): Promise<boolean> {
    return this.router.navigate([ROUTE.ERROR.MAIN, errorCode].filter(Boolean));
  }
}
